import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from 'react-query'

import { APIURL } from '../../constants'
import services from '../services'
import TileCarousel from './TileCarousel'
import styled from 'styled-components'

import { ProductH3 } from '../theme/default/base'

const Header = styled(ProductH3)`
  margin-top: 20px;
  margin-bottom: 10px;
  color: ${(props) => props.theme.colors.black};
  text-align: center;
`

const RelatedProducts = ({ slug }) => {
  const queryFunc = () => {
    return services.get_v2(APIURL.API_MARKETPLACE_RELATED(slug))
  }
  const { isLoading, error, data } = useQuery(`relatedData${slug}`, queryFunc)
  if (isLoading || error) {
    return ''
  }

  if (data && data?.response?.length === 0) {
    return ''
  }

  return (
    <div>
      <Header>Related Solutions</Header>
      <TileCarousel products={data.response} />
    </div>
  )
}

RelatedProducts.propTypes = {
  slug: PropTypes.string
}

export default RelatedProducts
